module.exports = __webpack_public_path__ + "img/Side_right.2a76ba3e.jpg";